export default __webpack_public_path__ + "static/media/pga-logo.ef5dba09.png";